import { Input } from '@angular/core';
import { ViewChildren } from '@angular/core';
import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.scss']
})
export class OtpInputComponent implements OnInit {

  otpInputList:Array<any> = [null, null, null, null, null, null];
  @ViewChildren('otp') rows: any;

  incompleteOtp = false;
  @Input() invalidOtp = false;

  constructor() { }

  ngOnInit(): void {
  }

  onKey(event:any, i:number) {
    var key:any = null;
    if(event.keyCode == 229){
      console.log("Input through mobile")
      key = event.target.value;
    }
    else{
      key = event.key;
    }
    console.log('key', key);
    console.log('index ',i);
    if( i < this.otpInputList.length){
      if("0123456789".includes(key)) {
        this.rows._results[i].nativeElement.value = key;
        // this.otpInputList[i] = key;
        if(i < this.otpInputList.length-1){
          this.rows._results[i+1].nativeElement.value = ''
          this.rows._results[i+1].nativeElement.focus();
        }
      }else if(key.toString().toLowerCase() === 'backspace') {
        this.rows._results[i].nativeElement.value = '';
        if(i > 0){
          this.rows._results[i-1].nativeElement.focus();
        }
      }else if(key.toString().toLowerCase() === 'arrowleft' && i > 0) {
        this.rows._results[i-1].nativeElement.focus();
      }else if(key.toString().toLowerCase() === 'arrowright') {
        if(i < this.otpInputList.length-1){
          this.rows._results[i+1].nativeElement.focus();
        }
      }else{
        this.rows._results[i].nativeElement.value='';
        this.rows._results[i].nativeElement.focus();
      }
    }
  }

  otpValue() {
    let otp = "";
    for(var i=0;i<this.otpInputList.length;i++){
      otp+=this.rows._results[i].nativeElement.value;
    }
    if(otp.length != this.otpInputList.length){
      this.incompleteOtp = true;
      return null;
    }
    this.incompleteOtp = false;
    return otp;
  }

  resetOtpValue(){
    for(var i=0;i<this.otpInputList.length;i++){
      this.rows._results[i].nativeElement.value="";
    }
  }

}
